import {
  Button,
  ButtonVariant,
  InputGroup,
  TextInput,
  ToolbarFilter,
} from '@patternfly/react-core'
import { SearchIcon } from '@patternfly/react-icons'
import * as React from 'react'
import { useCallback, useMemo } from 'react'

import { FilterCategories, FilterLabels } from './filters'

interface Props {
  mrn: string
  showToolbarItem: boolean
  onMrnUpdated: (mrn?: string) => void
}

export const MRNToolbarFilter = ({
  mrn,
  onMrnUpdated,
  showToolbarItem,
}: Props) => {
  const onChange = useCallback(
    (value: string) => {
      onMrnUpdated(value)
    },
    [onMrnUpdated],
  )

  const onDelete = useCallback(() => {
    onMrnUpdated(null)
  }, [onMrnUpdated])

  const mrnChips = useMemo(() => {
    return mrn ? [mrn] : []
  }, [mrn])

  return (
    <ToolbarFilter
      chips={mrnChips}
      deleteChip={onDelete}
      categoryName={FilterLabels[FilterCategories.MRN]}
      showToolbarItem={showToolbarItem}
    >
      <InputGroup>
        <TextInput
          name="nameInput"
          type="search"
          aria-label="name filter"
          onChange={onChange}
          value={mrn ? mrn : ''}
          placeholder="Filter by MRN..."
        />
        <Button
          variant={ButtonVariant.control}
          aria-label="search button for search input"
        >
          <SearchIcon />
        </Button>
      </InputGroup>
    </ToolbarFilter>
  )
}
